/* MCD Scroll-Story Homepage (W3-Port des Prototyps v10, 2026-07-12).
   Aenderungen ggue. Prototyp: Akzent fix teal (Dev-Switch raus), Lenis/html2canvas
   self-hosted, Live-3D-GLB ersetzt durch vorgerenderte Spin-Frames (IP-Schutz),
   CTAs fuehren zur R1-PDP (Konfig im JSON-Island #mcd-story-data). */
(function () {
  /* Fallback, falls mcd-ui.js (Baukasten) nicht geladen ist: ohne Einrasten weiterlaufen */
  window.MCD = window.MCD || {}; MCD.beat = MCD.beat || function (p) { return p; };
  const R = document.querySelector(".mcd-story");
  if (!R) return;
  let CFG;
  try {
    CFG = JSON.parse(document.getElementById("mcd-story-data").textContent);
  } catch (e) {
    /* Ohne Konfig keine Choreografie — Inhalt sichtbar machen und aussteigen */
    document.body.classList.remove("mcd-story-page");
    document.querySelectorAll(".mcd-story .pre").forEach(p => p.classList.add("done"));
    console.warn("mcd-story: Konfig fehlt", e);
    return;
  }

  /* Stabile Viewport-Hoehe (In-App-Browser 05.08.): Instagram/TikTok klappen ihre
     Leisten beim Scrollen ein/aus -> innerHeight aendert sich mitten im Scroll und
     alle vh()-basierten Effekte springen. Hoehe nur uebernehmen, wenn sich die
     Breite aendert (Rotation/echtes Resize) oder der Sprung >150px ist. */
  let _vw = window.innerWidth, _vh = window.innerHeight;
  addEventListener("resize", () => {
    if (window.innerWidth !== _vw || Math.abs(window.innerHeight - _vh) > 150) {
      _vw = window.innerWidth; _vh = window.innerHeight;
    }
  });
  const vh = () => _vh;
  const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
  const easeO = t => 1 - Math.pow(1 - t, 3);
  const $ = s => R.querySelector(s);
  const $$ = s => Array.from(R.querySelectorAll(s));
  const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  const touch = matchMedia("(hover:none)").matches;
  const mobileV = matchMedia("(max-width:900px)").matches; /* wie der CSS-Mobil-Block */
  const params = new URLSearchParams(location.search);
  const noSmooth = params.get("shoot") === "1";

  /* ===== Char-Splitter ===== */
  function splitChars(el, base) {
    let idx = 0;
    function wrapWord(word, host) {
      const w = document.createElement("span"); w.className = "w";
      for (const c of word) {
        const s = document.createElement("span"); s.className = "ch";
        s.style.setProperty("--d", (base + idx * 0.016).toFixed(3) + "s");
        s.textContent = c; w.appendChild(s); idx++;
      }
      host.appendChild(w);
    }
    function processNode(node, host) {
      if (node.nodeType === 3) {
        const parts = node.textContent.split(/(\s+)/);
        parts.forEach(p => {
          if (!p) return;
          if (/^\s+$/.test(p)) host.appendChild(document.createTextNode(" "));
          else wrapWord(p, host);
        });
      } else if (node.nodeType === 1) {
        const cl = node.cloneNode(false); host.appendChild(cl);
        Array.from(node.childNodes).forEach(ch => processNode(ch, cl));
      }
    }
    const src = Array.from(el.childNodes);
    el.textContent = "";
    src.forEach(n => processNode(n, el));
  }
  $$(".chars").forEach(el => { if (!reduce) { el._origHtml = el.innerHTML; splitChars(el, 0.05); } });

  /* ===== Scramble ===== */
  const GLYPHS = "▮▯01/\\|<>*#";
  function scramble(el) {
    if (reduce || el.dataset.done) return;
    el.dataset.done = "1";
    const final = el.textContent;
    const t0 = performance.now(), dur = 900;
    (function tick(now) {
      const p = clamp((now - t0) / dur, 0, 1);
      const solved = Math.floor(final.length * easeO(p));
      let out = "";
      for (let i = 0; i < final.length; i++) {
        const c = final[i];
        out += i < solved || c === " " ? c : GLYPHS[(Math.random() * GLYPHS.length) | 0];
      }
      el.textContent = out;
      if (p < 1) requestAnimationFrame(tick); else el.textContent = final;
    })(t0);
  }

  /* ===== Smooth Scroll + Velocity ===== */
  let lenis = null, velo = 0, lastY = window.scrollY, lastT = performance.now();
  if (window.Lenis && !reduce && !noSmooth) {
    lenis = new Lenis({ lerp: 0.12, wheelMultiplier: 1.4 });
    lenis.on("scroll", e => { velo = e.velocity || 0; onScroll(); });
    (function raf(t) { lenis.raf(t); requestAnimationFrame(raf); })(0);
  } else {
    addEventListener("scroll", () => {
      const now = performance.now(), y = window.scrollY;
      velo = (y - lastY) / Math.max(1, now - lastT) * 16;
      lastY = y; lastT = now; onScroll();
    }, { passive: true });
  }

  const scanLineEl = $("#scanLine"), scanTagEl = $("#scanTag");
  let lastScanPct = -1;

  /* ===== Preloader ===== */
  const pre = $("#pre"), preCount = $("#preCount"), preBoot = $("#preBoot");
  const BOOT = ["BOOT · AERO OS", "LOADING ASSETS", "CALIBRATING WINGS", "READY."];
  let pc = 0, bootI = 0;
  const bootT = setInterval(() => {
    bootI = Math.min(BOOT.length - 1, bootI + 1);
    preBoot.textContent = BOOT[bootI];
    if (bootI === BOOT.length - 1) clearInterval(bootT);
  }, noSmooth ? 60 : 95);
  /* Perf 2026-07-25 (Jonas-GO "erster Bildschirm sofort"): Preloader-Takt von
     82ms/200ms auf 26ms/70ms — der Vollbild-Layer verdeckte den Hero ~1,2s,
     der Hero-Text wurde erst DANACH eingeblendet => LCP frühestens ~2s.
     Optik (MCD. / BOOT-Zeilen / 00-100) bleibt identisch, nur zügiger. */
  const pcT = setInterval(() => {
    pc = Math.min(100, pc + Math.ceil(Math.random() * 16));
    preCount.textContent = String(pc).padStart(2, "0") + " / 100";
    if (pc >= 100) {
      clearInterval(pcT);
      setTimeout(() => {
        pre.classList.add("done");
        $("#heroH1").classList.add("is-in");
        $$("#s0 [data-scramble]").forEach(scramble);
      }, noSmooth ? 60 : 70);
    }
  }, noSmooth ? 16 : 26);

  /* ===== Magnet-CTAs ===== */
  if (!touch && !reduce) $$("[data-magnet]").forEach(el => {
    let tx = 0, ty = 0, rx = 0, ry = 0;
    addEventListener("mousemove", e => {
      const r = el.getBoundingClientRect();
      const dx = e.clientX - (r.left + r.width / 2), dy = e.clientY - (r.top + r.height / 2);
      const d = Math.hypot(dx, dy);
      const pull = d < 130 ? (1 - d / 130) * 12 : 0;
      tx = (dx / (d || 1)) * pull; ty = (dy / (d || 1)) * pull;
    });
    let magLast = "";
    (function mag() { rx += (tx - rx) * .18; ry += (ty - ry) * .18;
      const t = `translate(${rx.toFixed(2)}px,${ry.toFixed(2)}px)`;
      if (t !== magLast) { el.style.transform = t; magLast = t; } /* 24.09.: nur bei Bewegung schreiben */
      requestAnimationFrame(mag); })();
  });

  /* Marquee entfernt (Jonas 13.07.) */

  /* Hero-RGB-Split ENTFERNT (Jonas 13.07.: flackerte bei jedem Scroll-Ansatz —
     nur der Aero-Scan bleibt). Stattdessen: MOLTENCORE-Wasserzeichen hinter dem
     Bike, zieht auf, sobald die Headline ausblendet (Steuerung in frame()). */
  const heroMediaEl = $("#heroMedia");
  const hwordEl = $("#hword");
  const hwordFEl = $("#hwordF");
  let lastWm = -1;
  let wmFront = false;
  /* Endgroesse als FONT-SIZE setzen und nur noch RUNTERskalieren (Jonas 13.07.:
     hochskalierter Text-Layer wurde weich gerastert = "schlechte Qualitaet";
     Endzustand scale(1,1) = native Schaerfe). Kappung 96vw bleibt (M/E-Schnitt). */
  const wmFit = () => {
    if (!hwordEl) return;
    hwordEl.style.fontSize = "";
    if (hwordFEl) hwordFEl.style.fontSize = "";
    const basePx = parseFloat(getComputedStyle(hwordEl).fontSize);
    const fit = Math.min(1.27, Math.max(0.8, (innerWidth * 0.96) / hwordEl.offsetWidth));
    const px = (basePx * fit).toFixed(1) + "px";
    hwordEl.style.fontSize = px;
    if (hwordFEl) hwordFEl.style.fontSize = px;
    lastWm = -1;
  };
  wmFit(); addEventListener("resize", wmFit);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(wmFit);

  /* ===== SPD ===== */
  const spdVal = $("#spdVal");
  /* 24.09. Tempo: nur schreiben, wenn sich der Wert aendert. Vorher 60x/s derselbe Text
     -> Stil-Neuberechnung der ganzen Seite in jedem Bild (2,8 s von 4 s Leerlauf-Rechenzeit). */
  let spdLast = "";
  (function spd() {
    const v = String(Math.min(999, Math.round(Math.abs(velo) * 14))).padStart(3, "0");
    if (v !== spdLast) { spdVal.textContent = v; spdLast = v; }
    requestAnimationFrame(spd);
  })();

  /* ===== Odometer ===== */
  function buildOdo(el) {
    const target = el.dataset.odo;
    el.textContent = "";
    const cols = [];
    for (const c of target) {
      if (c >= "0" && c <= "9") {
        const col = document.createElement("span"); col.className = "col";
        for (let d = 0; d <= 9; d++) { const s = document.createElement("span"); s.textContent = d; col.appendChild(s); }
        el.appendChild(col); cols.push({ col, d: +c });
      } else {
        const sym = document.createElement("span"); sym.className = "col sym"; sym.innerHTML = `<span>${c}</span>`;
        el.appendChild(sym); cols.push(null);
      }
    }
    el._fire = () => cols.forEach((c, i) => {
      if (!c) return;
      setTimeout(() => {
        /* Prozent der Spalten-Eigenhoehe (10 Ziffern) statt px-Messung:
           die Spalte ist IMMER exakt 10 Ziffern hoch, -d*10% landet daher
           auf jeder Ziffer punktgenau — immun gegen Font-Load-/Layout-/
           Resize-Timing (Jonas 18.07.: mobil sprang 20.000->30.000, 5->8,
           weil der px-Schritt zeitweise mit Desktop-Groesse gemessen wurde). */
        c.col.style.transform = `translateY(${(-c.d * 10).toFixed(1)}%)`;
      }, i * 90);
    });
    if (reduce) { el._fire = null; el.textContent = target; }
  }
  $$(".odo").forEach(buildOdo);

  /* ===== Tacho-Gauges ===== */
  const GA0 = 225, GA1 = 495;
  function gpolar(r, deg) {
    const a = (deg - 90) * Math.PI / 180;
    return [50 + r * Math.cos(a), 56 + r * Math.sin(a)];
  }
  function garc(r, a0, a1) {
    const [x0, y0] = gpolar(r, a0), [x1, y1] = gpolar(r, a1);
    return `M ${x0.toFixed(1)} ${y0.toFixed(1)} A ${r} ${r} 0 ${a1 - a0 > 180 ? 1 : 0} 1 ${x1.toFixed(1)} ${y1.toFixed(1)}`;
  }
  function buildGauge(n) {
    const frac = clamp(parseFloat(n.dataset.gauge || "0"), 0, 1);
    const line = n.querySelector(".num-line");
    if (!line) return;
    const NS = "http://www.w3.org/2000/svg";
    const svg = document.createElementNS(NS, "svg");
    svg.setAttribute("class", "gauge"); svg.setAttribute("viewBox", "0 0 100 100"); svg.setAttribute("aria-hidden", "true");
    const mk = (cls, d) => { const p = document.createElementNS(NS, "path"); p.setAttribute("class", cls); p.setAttribute("d", d); svg.appendChild(p); return p; };
    mk("trk", garc(38, GA0, GA1 - 40));
    mk("redz", garc(38, GA1 - 38, GA1));
    for (let t = 0; t <= 4; t++) {
      const deg = GA0 + (GA1 - GA0) * t / 4;
      const [x0, y0] = gpolar(32, deg), [x1, y1] = gpolar(37, deg);
      const l = document.createElementNS(NS, "line");
      l.setAttribute("class", "tick");
      l.setAttribute("x1", x0); l.setAttribute("y1", y0); l.setAttribute("x2", x1); l.setAttribute("y2", y1);
      svg.appendChild(l);
    }
    const val = mk("val", garc(38, GA0, GA1));
    val.setAttribute("pathLength", "100");
    val.style.strokeDasharray = "100";
    val.style.strokeDashoffset = "100";
    const ndl = document.createElementNS(NS, "line");
    ndl.setAttribute("class", "ndl");
    const [nx, ny] = gpolar(28, GA0);
    ndl.setAttribute("x1", 50); ndl.setAttribute("y1", 56); ndl.setAttribute("x2", nx); ndl.setAttribute("y2", ny);
    svg.appendChild(ndl);
    const hub = document.createElementNS(NS, "circle");
    hub.setAttribute("class", "hub"); hub.setAttribute("cx", 50); hub.setAttribute("cy", 56); hub.setAttribute("r", 2.6);
    svg.appendChild(hub);
    const row = document.createElement("div"); row.className = "num-row";
    line.parentNode.insertBefore(row, line);
    row.appendChild(svg); row.appendChild(line);
    const setTo = () => {
      val.style.strokeDashoffset = String(100 * (1 - frac));
      ndl.style.transform = `rotate(${(GA1 - GA0) * frac}deg)`;
    };
    n._gauge = () => {
      setTo();
      if (frac === 0 && !reduce) ndl.animate(
        [{ transform: "rotate(0deg)" }, { transform: "rotate(16deg)", offset: .35 }, { transform: "rotate(0deg)" }],
        { duration: 950, easing: "cubic-bezier(.22,1,.36,1)" });
    };
    if (reduce) { n._gauge = null; setTo(); }
  }
  $$(".numbers .n[data-gauge]").forEach(buildGauge);

  /* ===== Glitch + Pixel-Explosion (geteiltes Modul, v2: Shards aus Seiten-Fotos) ===== */
  const glitch = window.MCDGlitch ? MCDGlitch.init({ boom: true, sources: CFG.glitchSrcs || [] }) : { pixelBoom: (x, y, mid) => mid() };

  function jumpTo(sel) {
    const el = $(sel); if (!el) return;
    const y = window.scrollY + el.getBoundingClientRect().top;
    if (lenis) lenis.scrollTo(y, { immediate: true }); else window.scrollTo(0, y);
    onScroll();
  }
  $$(".cta").forEach(a => a.addEventListener("click", e => {
    const target = a.getAttribute("href");
    e.preventDefault();
    glitch.pixelBoom(e.clientX || innerWidth / 2, e.clientY || innerHeight / 2, () => {
      if (target && target.startsWith("#") && target.length > 1) jumpTo(target);
      else if (target && target !== "#") location.href = target;
    });
  }));

  /* ===== Lineup: Wing-Spin-Videos nur laden/abspielen, wenn die Karte in
     Sichtweite kommt (Perf 13.07.: vorher zogen alle 3 sofort ~6MB — Mobil-Lag) ===== */
  $$(".mcard .spin video").forEach(v => {
    new IntersectionObserver(es => es.forEach(e => {
      if (e.isIntersecting) v.play().catch(() => {});
      else v.pause();
    }), { rootMargin: "300px" }).observe(v);
  });

  /* ===== Blueprint-Wing: vorgerenderte Spin-Frames (W3-Ersatz fuer Live-GLB).
     Auto-Rotation + Drag-Scrub, pausiert offscreen. ===== */
  (function wingSpin() {
    const host = $("#wing3d");
    if (!host) return;
    const cv = document.createElement("canvas");
    host.appendChild(cv);
    const ctx = cv.getContext("2d");
    const N = CFG.spinCount || 120;
    const pad = i => "f" + String(i).padStart(2, "0") + ".webp"; /* Perf 13.07.: WebP statt PNG (~50% Bytes) */
    const imgs = []; let loaded = 0, ready = false;
    /* Perf (13.07.): Frames erst laden, wenn das Panel in die Naehe scrollt */
    new IntersectionObserver((es, io) => {
      if (!es[0].isIntersecting) return;
      io.disconnect();
      /* Perf 13.07.: max 5 Frames parallel statt 120 auf einmal (Netz nicht fluten) */
      let next = 0;
      const kick = () => {
        if (next >= N) return;
        const im = new Image();
        im.decoding = "async";
        /* onerror zaehlt mit: EIN kaputtes Frame darf den Viewer nicht dauerhaft blocken (Codex 13.07.) */
        im.onload = im.onerror = () => {
          if (im.decode) im.decode().catch(() => {}); /* Warm-Decode gegen Erst-Scroll-Lag (Jonas 13.07.) */
          /* Erst-Frame SOFORT zeigen (Jonas 16.07.: 'da stand dass das fehlt' —
             vorher blieb bis zum 120. Frame nur das Label sichtbar) */
          if (!firstDrawn && imgs[0] && imgs[0].complete && imgs[0].naturalWidth) { firstDrawn = true; drawIdx(0); }
          if (++loaded >= N) { ready = true; host.closest(".blueprint").classList.add("has3d"); } else kick();
        };
        im.src = CFG.spinBase + pad(next++);
        imgs.push(im);
      };
      for (let k = 0; k < 5; k++) kick();
    }, { rootMargin: "900px 0px" }).observe(host);
    function size() {
      const r = host.getBoundingClientRect();
      const dpr = Math.min(1.5, devicePixelRatio || 1);
      cv.width = Math.max(2, r.width * dpr); cv.height = Math.max(2, r.height * dpr);
    }
    size(); addEventListener("resize", size);
    let firstDrawn = false;
    const drawIdx = (i) => {
      const im = imgs[i];
      if (!(im && im.complete && im.naturalWidth)) return;
      const cw = cv.width, ch = cv.height;
      ctx.clearRect(0, 0, cw, ch);
      const s = Math.min(cw / im.naturalWidth, ch / im.naturalHeight) * 0.92;
      const dw = im.naturalWidth * s, dh = im.naturalHeight * s;
      ctx.drawImage(im, (cw - dw) / 2, (ch - dh) / 2, dw, dh);
    };
    let vis = false;
    new IntersectionObserver(es => es.forEach(e => { vis = e.isIntersecting; }), { threshold: 0 }).observe(host);
    /* Drag-Scrub entfernt (Jonas 13.07.) — nur Auto-Rotation */
    let frame = 0, tFrame = 0, drag = null, last = -1;
    const SPIN_MS = 7000; /* 5000 war zu schnell (Jonas 18.07.); 9000 war laggy (nur 120 Frames) -> 7000 als Kompromiss (~17fps) */
    let t0 = null, tOff = 0;
    (function loop(t) {
      requestAnimationFrame(loop);
      if (!vis || !ready) return;
      if (!drag && !reduce && !noSmooth) tFrame += N / (SPIN_MS / 16.7);
      frame += (tFrame - frame) * 0.2;
      const i = ((Math.round(frame) % N) + N) % N;
      if (i === last) return;
      last = i;
      drawIdx(i);
    })(0);
  })();

  /* ===== Scroll-Choreografie ===== */
  const sHero = $("#s0"), sHoriz = $("#s1"), sOpen = $("#s2");
  const heroGrid = $(".hero-grid");
  const track = $("#track"), hIdx = $("#hIdx");
  let trackTarget = 0, trackXcur = 0, phTarget = 0, phCur = 0, horizOn = false;
  const trackPhs = Array.from(track.querySelectorAll(".ph"));
  new IntersectionObserver(es => { horizOn = es[0].isIntersecting; R.classList.toggle("h-on", horizOn); }).observe(sHoriz);
  /* Mobil: Ein-Wisch-Pager statt Scroll-Scrub (Jonas 13.07. abends) — der
     Scrub-Loop bleibt komplett aus, der Pager besitzt das track-Transform. */
  if (mobileV && window.MCD.pager) {
    MCD.pager(track, { itemSel: ".mcard", onIndex: (i, n) => { hIdx.textContent = "0" + (i + 1) + " / 0" + n; } });
  }
  else (function trackRaf() {
    requestAnimationFrame(trackRaf);
    /* Style-Writes nur bei Sichtbarkeit oder Nachschwingen (R20-Muster) */
    if (!horizOn && Math.abs(trackTarget - trackXcur) < 0.1 && Math.abs(phTarget - phCur) < 0.1) return;
    const k = (noSmooth || reduce) ? 1 : 0.09;
    trackXcur += (trackTarget - trackXcur) * k;
    phCur += (phTarget - phCur) * k;
    track.style.transform = `translateX(${(-trackXcur).toFixed(1)}px)`;
    for (const ph of trackPhs) ph.style.transform = `translateX(${phCur.toFixed(1)}px)`;
  })();
  const openFrame = $("#openFrame"), openTitle = $("#openTitle"), openIntro = $("#openIntro");
  const openPh = openFrame.querySelector(".ph");
  const finPh = $("#finPh");
  const stations = $$(".rail .st");
  const sections = ["#s0", "#s1", "#s2", "#s3", "#s4"].map(s => $(s));

  function prog(sec) {
    const r = sec.getBoundingClientRect();
    return clamp(-r.top / (r.height - vh()), 0, 1);
  }

  let ticking = false;
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
  function frame() {
    ticking = false;

    const p0 = prog(sHero);
    const scan = 8 + clamp(p0, 0, 1) * 92;
    heroMediaEl.style.setProperty("--scan", scan.toFixed(2) + "%");
    scanLineEl.style.opacity = p0 > 0.965 ? "0" : "1";
    const pct = Math.round(clamp(p0, 0, 1) * 100);
    if (pct !== lastScanPct) { lastScanPct = pct; scanTagEl.textContent = "AERO SCAN · " + String(pct).padStart(2, "0") + "%"; }
    if (!reduce) {
      /* Headline frueher raus (Jonas-Halte-Umbau): weg bei 0.54, BEVOR das
         Wasserzeichen (ab 0.5) sichtbar aufzieht — sonst Ueberlagerung */
      heroGrid.style.opacity = String(clamp(1 - (p0 - 0.32) / 0.22, 0, 1));
      heroGrid.style.transform = `translateY(${p0 * -70}px)`;
    }
    /* MOLTENCORE-Wasserzeichen: zieht auf, wenn die Headline weg ist, und
       waechst dabei nach links+rechts (Jonas 13.07.) — nur transform/opacity */
    if (hwordEl) {
      /* Front-Glitch (Jonas 13.07. abends): Ankunft frueher (p0 0.74) + Hero auf
         240vh — nach der Ankunft haelt der Hero noch ~36vh, erst DANN geht es
         weiter ("erst wenn das MOLTENCORE mittig da ist, wird weiter gescrollt").
         Hysterese 0.68 gegen Flackern an der Schwelle; Optik in wmTear (CSS) */
      if (hwordFEl) {
        const want = wmFront ? p0 >= (mobileV ? 0.6 : 0.68) : p0 >= 0.74;
        if (want !== wmFront) {
          wmFront = want;
          hwordFEl.classList.toggle("won", wmFront);
          heroMediaEl.classList.toggle("wfront", wmFront);
          lastWm = -1;
        }
      }
      const wm = Math.round(clamp((p0 - 0.5) / 0.22, 0, 1) * 200) / 200;
      if (wm !== lastWm) {
        lastWm = wm;
        hwordEl.style.opacity = (wm * 0.9 * (wmFront ? 0.35 : 1)).toFixed(3);
        const tf = `translate(-50%,-50%) scale(${(0.6 + 0.4 * wm).toFixed(3)},${(0.85 + 0.15 * wm).toFixed(3)})`;
        hwordEl.style.transform = tf;
        if (hwordFEl) hwordFEl.style.transform = tf;
      }
    }

    if (!mobileV) {
      const p1 = prog(sHoriz);
      /* Desktop LINEAR (Jonas 13.07. spaet: Einrast-Haltefenster fuehlten sich
         wie Scroll-Sperre an — Rasten gehoert nur mobil in den Pager) */
      trackTarget = p1 * (track.scrollWidth - window.innerWidth + window.innerWidth * 0.07);
      phTarget = (p1 - 0.5) * 24;
      hIdx.textContent = "0" + (1 + Math.min(2, Math.round(p1 * 2))) + " / 03";
    }

    const p2 = prog(sOpen);
    const g = easeO(clamp(p2 / 0.72, 0, 1));
    const ix = 21 - g * 21, iy = 18 - g * 18;
    openFrame.style.clipPath = `inset(${iy.toFixed(2)}% ${ix.toFixed(2)}% ${iy.toFixed(2)}% ${ix.toFixed(2)}%)`;
    openPh.style.transform = `scale(${(1.18 - g * 0.12).toFixed(4)})`;
    /* Intro "First release in the line" (Jonas 16.07.): steht waehrend das
       Fenster aufgeht, driftet leicht nach oben und ist WEG bevor der Titel kommt */
    if (openIntro) {
      const ti = clamp((p2 - 0.03) / 0.11, 0, 1) * (1 - clamp((p2 - 0.36) / 0.14, 0, 1));
      openIntro.style.opacity = ti.toFixed(3);
      openIntro.style.transform = `translateY(${((0.25 - Math.min(p2, 0.6)) * 56).toFixed(1)}px)`;
    }
    const t = clamp((p2 - 0.55) / 0.3, 0, 1);
    openTitle.style.opacity = String(t);
    openTitle.style.transform = `translateY(${(1 - t) * 30}px)`;
    if (t > 0.15) openTitle.querySelectorAll("[data-scramble]").forEach(scramble);

    const rF = sections[4].getBoundingClientRect();
    if (rF.top < vh() && rF.bottom > 0) {
      const pf = clamp(1 - rF.top / vh(), 0, 1.6);
      /* Parallax halbiert (Jonas 13.07. abends: weniger Zoom noetig = weniger Reserve) */
      finPh.style.transform = `translateY(${(pf - 0.8) * 14}px)`;
    }

    $$('.pfx[data-vis="1"]').forEach(el => {
      const r = el.getBoundingClientRect();
      const p = clamp(1 - r.top / vh(), 0, 1);
      el.style.transform = `translateY(${(p - 0.5) * 36}px)`;
    });

    let curSt = 0;
    sections.forEach((sec, i) => { if (sec.getBoundingClientRect().top < vh() * 0.4) curSt = i; });
    stations.forEach((st, i) => st.classList.toggle("on", i === curSt));
  }
  frame();

  /* ===== Reveals ===== */
  const io = new IntersectionObserver(es => es.forEach(e => {
    if (!e.isIntersecting) return;
    e.target.classList.add("is-in");
    e.target.querySelectorAll("[data-scramble]").forEach(scramble);
    if (e.target.matches("[data-scramble]")) scramble(e.target);
    e.target.querySelectorAll(".odo").forEach(o => o._fire && o._fire());
    if (e.target._gauge) setTimeout(e.target._gauge, 180);
    /* iOS-Layer-Fix (Jonas 16.07.: Text bei "Three platforms" blinkte beim Scrollen):
       nach der Buchstaben-Intro die vielen .ch-Spans wieder zu normalem Text
       plaetten — echtes Safari droppt sonst gelegentlich die Composited-Layer. */
    if (e.target.classList.contains("chars") && e.target._origHtml) {
      const n = e.target.querySelectorAll(".ch").length;
      setTimeout(() => { e.target.innerHTML = e.target._origHtml; }, n * 50 + 1400);
    }
    io.unobserve(e.target);
  }), { threshold: 0.25 });
  $$("[data-reveal], .chars[data-io]").forEach(el => io.observe(el));
  $$(".beat .kicker[data-scramble], .mcard .num[data-scramble], .mcard .sl[data-scramble]").forEach(el => io.observe(el));

  const ioP = new IntersectionObserver(es => es.forEach(e => e.target.dataset.vis = e.isIntersecting ? "1" : ""), { threshold: 0 });
  $$(".pfx").forEach(el => ioP.observe(el));
})();
